export const Checkboxes = {
  TermsConditionsCopy: 'terms-and-conditions-copy',
};
